import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

/**
 * Auto-opens a modal when the URL carries `?openModal=<paramValue>`, then strips
 * the param so refresh/back doesn't reopen it. Used so dashboard quick actions can
 * deep-link into a list page's existing "add" modal instead of a separate page.
 */
export default function useOpenModalParam(paramValue, onOpen, ready = true) {
    const location = useLocation();
    const history = useHistory();
    const handledRef = useRef(false);

    useEffect(() => {
        if (handledRef.current || !ready) return;

        const params = new URLSearchParams(location.search);
        if (params.get("openModal") !== paramValue) return;

        handledRef.current = true;
        onOpen();

        params.delete("openModal");
        history.replace({ pathname: location.pathname, search: params.toString() });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready, location.search]);
}
